import React, { useState, useEffect, Fragment, useContext } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import ModalPop from 'components/sales/modal/modal';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { Button } from 'react-bootstrap';
import localization from 'assets/localization/localization';
import Images from 'assets/images/imageData';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import './actionDropDown.css';
const ActionDropDown = ({
  id,
  actionList,
  detailList,
  status,
  manageId,
  postUpdatePMStatus = null,
  postApprovePmSite = null,
  postUpdateRMStatus = null,
  postUpdateEMStatus = null,
  deleteCorpClient = null,
  updateCorpClient = null,
  deleteMrfDetail = null,
  refreshPage = null,
  updateMrf = null,
  setIsbulk = false,
  setFileUrl,
  setShowAddAdvancePopup = () => {},
  setShowAddPaymentPopup = () => {},
  setShowAdjustAdvancePopup = () => {},
  setShowDetailsPopup = () => {},
  setCurrentBusinessId = () => {},
  setCurrentInvoiceId = () => {},
  setCurrentInvoiceNumber = () => {},
  setCurrentDocumentType = () => {},
  setCurrentContractId = () => {},
  setCurrentSiteNumber = () => {},
  setCurrentBusinessName = () => {},
  setCurrentRowData = () => {},
  setCurrentContractType = () => {},
  setIsView = () => {},
  setIsEdit = () => {},
  setChangeStatus = () => {},
  setCarnivalId = () => {},
  setProjectId = () => {},
  setStartDate = () => {},
  setEndDate = () => {},
  setCurrentcarnivalStatus = () => {},
  setShowRaisePopup = () => {},
  setPaymentReference = () => {},
  setModeOfCollection = () => {},
  setUnclaimedAmount = () => {},
  setShowEditCreditPopup = () => {},
  setCreditLimit = () => {},
  setCreditExhausted = () => {},
  setCreditRemaining = () => {},
  setUserId = () => {},
  setUserName = () => {},
  setDepartmentId = () => {},
  setDepartmentName = () => {},
  setType = () => {},
  setMonthlyAverageRevenue = () => {},
  setShowRetagInvoicePopup = () => {},
  setEmployeeCreditLimit = () => {},
  setEmployeeCreditRemaining = () => {},
  setResponsibleEmail = () => {},
  setEmployeeTeamId = () => {},
  setEmployeeTeamName = () => {},
  setResponsibleDepartment = () => {},
  setEmployeeResponsibleEmail = () => {},
  setEmployeeResponsibleDepartment = () => {},
  setEmployeeDepartmentId = () => {},
  setTeamId = () => {},
  setTeamName = () => {},
  setExpectedCreditLimit = () => {},
  setLateFeeApplicable = () => {},
  setLateFee = () => {},
  setDueDate = () => {},
  dontAppendLink = false,
  setUnclaimedId = () => {},
  assignEngineerPopup = () => {},
  changeResponsibleManagerPopup = () => {},
  installmentRequestId = () => {},
  setCloseModal = () => {},
  closeModal=false,
  setInvoiceValidationCompletePopup= () => {},
  setCampaignId= () => {},
  carLoanId= () => {},
  setChangeCarLoanStatusModalOpen= () => {},
  setBankSheetId= () => {},
  setContractStatusModalOpenForContractExpiry= () => {},
  setRequestForContractExpiry= () => {},
  setCentralTechChangeAssigns= () => {},
  setChangeAssignModalOpenForCentralTech= () => {},
  setShowLobChangeStatus = () => {},
  setSelectedLob = () => {},
  setLobCurrentStatus = () => {},
  setShowAssignLocationPopup = () => {},
  setLocationAssignUserId,
  setShowAssigReporteePopup = () => {},
  setReportingToRoleId,
  setShowDeleteMrfTypePopup = () => {},
  setSelectedMrfTypeId = () => {},
  setSelectedOrderId = () => {},
  setShowBulkCsv = () => {},
}) => {
  const [actionData, setactionData] = useState('');
  const [leadId, setLeadId] = useState('');
  const [isModal, setIsModal] = useState(false);
  const [isFiled, setIsFiled] = useState(false);
  const [assigneeId, setAssigneeId] = useState('');
  const [successModal, setSuccessModal] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [deleteCorClient, setDeleteCorClient] = useState(false);
  const [deleteMrfModal, setDeleteMrfModal] = useState(false);
  const [updateMrfDetail, setUpdateMrfDetail] = useState(false);
  const [editClientData, setEditClientData] = useState({
    id: '',
    company_name: '',
  });

  useEffect(() => {
    if (id || actionList) {
      setactionData(actionList);
      setLeadId(id);
      if (
        (status &&
          typeof status === 'string' &&
          status.toLowerCase() === 'approval pending') ||
        (status &&
          typeof status === 'string' &&
          status.toLowerCase() === 'rejected') ||
        (status &&
          typeof status === 'string' &&
          status.toLowerCase() === 'completed')
      ) {
        const filterdData = actionList.filter((item) => {
          if(item){
            return item.name.toLowerCase() !== 'postsale data';
          }

        });
        setactionData(filterdData);
      }
      if (
        status &&
        typeof status === 'string' &&
        status.toLowerCase() === 'completed'
      ) {
        const filterdData = actionList.filter((item) => {
          return (
            item.name.toLowerCase() !== 'postsale data' &&
            item.name.toLowerCase() !== 'change assignee'
          );
        });
        setactionData(filterdData);
      }
    }
  }, [id, actionList, status]);

  const openHideModal = () => setIsModal(false);

  const handleSelect = async () => {
    const data =
      (await detailList) && detailList &&
      detailList.filter((item) =>
        item.id
          ? item.id === id
            ? item.id === id
            : item.site_id === id
          : item.site_id === id
      );
    await localStorage.setItem('viewDetail', JSON.stringify(data));
  };

  const approvePm = (name, id) => {
    if (postUpdatePMStatus !== null) {
      if (name === 'Approve') {
        setIsModal(true);
      }
    }
    if (postApprovePmSite !== null) {
      (async () => {
        if (manageId) {
          const res = await postApprovePmSite(manageId);
          if (res === true) {
            setSuccessModal(true);
            refreshPage(true);
          }
        }
      })();
    }
    if (postUpdateRMStatus !== null) {
      const data = {
        rm_ticket_id: id,
        status: 5,
      };
      (async () => {
        if (id) {
          const res = await postUpdateRMStatus(data);
          if (res === true) {
            setSuccessModal(true);
            refreshPage(true);
          }
        }
      })();
    }
    if (postUpdateEMStatus !== null) {
      const data = {
        em_ticket_id: id,
        status: 5,
      };
      if (id) {
        (async () => {
          const res = await postUpdateEMStatus(data);
          if (res === true) {
            setSuccessModal(true);
            refreshPage(true);
          }
        })();
      }
    }
  };

  const reopenPm = (id) => {
    if (postUpdatePMStatus !== null) {
      (async () => {
        if (id) {
          const data = {
            pm_ticket_id: id,
            status: 4,
          };
          const res = await postUpdatePMStatus(data);
          if (res === true) {
            setSuccessModal(true);
            refreshPage(true);
          }
        }
      })();
    }
    if (postUpdateRMStatus !== null) {
      const data = {
        rm_ticket_id: id,
        status: 4,
      };
      (async () => {
        if (id) {
          const res = await postUpdateRMStatus(data);
          if (res === true) {
            setSuccessModal(true);
            refreshPage(true);
          }
        }
      })();
    }
    if (postUpdateEMStatus !== null) {
      const data = {
        em_ticket_id: id,
        status: 4,
      };
      (async () => {
        if (id) {
          const res = await postUpdateEMStatus(data);
          if (res === true) {
            setSuccessModal(true);
            refreshPage(true);
          }
        }
      })();
    }
  };

  const updatePMStatus = async () => {
    const data = {
      pm_ticket_id: id,
      status: assigneeId,
    };
    if (assigneeId !== '') {
      const res = await postUpdatePMStatus(data);
      if (res === true) {
        setIsModal(false);
        refreshPage(true);
      }
    }
  };

  const editClient = (id) => {
    setEditClientData({ ...editClientData, id: id });
    setEditModal(true);
  };

  const deleteClient = (id) => {
    setDeleteCorClient(true);
  };

  const deleteClientCrop = async () => {
    if (id) {
      const res = await deleteCorpClient(id);
      if (res) {
        setDeleteCorClient(false);
        refreshPage(true);
      }
    }
  };

  const updateCorp = async () => {
    if (editClientData.company_name !== '' && editClientData.id !== '') {
      const res = await updateCorpClient(editClientData);
      if (res) {
        setEditModal(false);
        refreshPage(true);
      }
    }
  };

  const deleteMrf = async () => {
    setDeleteMrfModal(true);
  };

  const deleteMrfDetails = async () => {
    if (id) {
      const res = await deleteMrfDetail(id);
      if (res) {
        refreshPage(true);
        setDeleteMrfModal(false);
      }
    }
  };

  const editMrf = async () => {
    const data =
      (await detailList) && detailList.filter((item) => item.id === id);
    setUpdateMrfDetail(data);
  };

  useEffect(() => {
    if (updateMrfDetail) {
      updateMrf(updateMrfDetail);
    }
  }, [updateMrfDetail]);

  return (
    <Fragment>
      <Dropdown className="position-relative" onSelect={handleSelect}>
        <Dropdown.Toggle
          className="btn dropdown-val dropddown_align"
          id="dropdown-basic"
        >
         
          :
        </Dropdown.Toggle>
        <Dropdown.Menu className="custom-dropdown scrollbar-styling">
          {actionData &&
            actionData.length &&
            actionData.map((item) => {
              // console.log('item', item);
              return (
                <Dropdown.Item
                  as={Link}
                  to={
                    dontAppendLink === false
                    ?
                      manageId !== undefined &&
                      item.name !== 'Approve' &&
                      item.name !== 'Upload Flat File' &&
                      item.name !== 'Download Flat File' &&
                      item.name !== 'Submit JMS'
                        ? `${item.link}/${leadId}/${manageId}`
                        : item.name === 'Maintenance Service PR'
                        ? `${item.link}/${leadId}?pr_type=5`
                        : item.name === 'Submit JMS'
                        ? `${item.link}`
                        : item.link !== ''
                        ? `${item.link}/${leadId}`
                        : '#'
                    : `${item.link}`

                  }
                  params={{
                    showButtons: item.showButtons ? item.showButtons : '',
                  }}
                  key={item.name}
                  onClick={(e) => {
                    if (item.name === 'Approve') {
                      approvePm(item.name, id);
                    }
                    if (item.name === 'Reject') {
                      reopenPm(id);
                    }
                    if (item.name === 'Edit Client') {
                      editClient(id);
                    }
                    if (item.name === 'Delete Client') {
                      deleteClient(id);
                    }
                    if (item.name === 'Delete') {
                      deleteMrf(id);
                    }
                    if (item.name === 'Edit') {
                      editMrf(id);
                    }
                    if (
                      item.name === 'Upload Flat File' ||
                      item.name === 'Download Flat File'
                    ) {
                      setIsbulk(id);
                      setFileUrl(item?.url);
                    }
                    if (item.name === 'Upload CSV') {
                      e.preventDefault()
                      setSelectedOrderId(item?.id);
                      setShowBulkCsv(true);
                    }
                    if (item.name === 'Add Advance') {
                      e.preventDefault()
                      setCurrentBusinessId(item?.businessId)
                      setShowAddAdvancePopup(true);
                      setCurrentInvoiceId(item?.invoiceId)
                      setCurrentInvoiceNumber(item?.invoiceNumber)
                      setCurrentContractId(item?.contractId);
                      setCurrentSiteNumber(item?.siteNumber)
                      setCurrentBusinessName(item?.businessName)
                      setCurrentContractType(item?.contractType)
                      setLateFeeApplicable(item?.is_late_fee_applicable)
                      setLateFee(item?.late_fee_amount)
                      setDueDate(item?.due_date)
                    }
                    if (item.name === 'Add Payment') {
                      console.log(item);
                      e.preventDefault()
                      setCurrentBusinessId(item?.businessId)
                      setShowAddPaymentPopup(true);
                      setCurrentInvoiceId(item?.invoiceId)
                      setCurrentInvoiceNumber(item?.invoiceNumber)
                      setCurrentDocumentType(item?.documentType)
                      setCurrentContractId(item?.contractId);
                      setCurrentSiteNumber(item?.siteNumber)
                      setCurrentBusinessName(item?.businessName)
                      setLateFeeApplicable(item?.is_late_fee_applicable)
                      setLateFee(item?.late_fee_amount)
                      setDueDate(item?.due_date)
                    }
                    if (item.name === 'Advance Adjustment') {
                      e.preventDefault()
                      setCurrentBusinessId(item?.businessId)
                      setShowAdjustAdvancePopup(true);
                      setCurrentInvoiceId(item?.invoiceId)
                      setCurrentContractId(item?.contractId);
                      setCurrentSiteNumber(item?.siteNumber)
                      setCurrentBusinessName(item?.businessName)
                      setLateFeeApplicable(item?.is_late_fee_applicable)
                      setLateFee(item?.late_fee_amount)
                      setDueDate(item?.due_date)
                    }
                    if (item.name === 'Change LOB Status') {
                      e.preventDefault();
                      setShowLobChangeStatus(true);
                      setSelectedLob(item?.id);
                      setLobCurrentStatus(item?.status)
                    }
                    if (item.name === 'View Detail') {
                      e.preventDefault()
                      setShowDetailsPopup(true)
                      setCurrentInvoiceId(item?.invoiceId)
                    }
                    if (item.name === 'Edit Request') {
                      e.preventDefault()
                      setIsView(false);
                      setIsEdit(true);
                      if (item?.rowData.request_type === 'ADVANCE') {
                        setShowAddAdvancePopup(true);
                      }
                      if (item?.rowData.request_type === 'PAYMENT') {
                        setShowAddPaymentPopup(true);
                      }
                      if (item?.rowData.request_type === 'ADJUSTMENT') {
                        setShowAdjustAdvancePopup(true);
                      }
                      setCurrentRowData(item?.rowData)
                      setCurrentBusinessId(item?.rowData.businessId)
                      setCurrentInvoiceId(item?.rowData.invoice_id)
                      setCurrentContractId(item?.rowData.contract_id);
                      setCurrentSiteNumber(item?.rowData.site_number)
                      setCurrentBusinessName(item?.rowData.business)
                      setCurrentContractType(item?.rowData.contract_type)
                      setLateFeeApplicable(item?.rowData.is_late_fee_applicable)
                      setLateFee(item?.rowData.late_fee_amount)
                      setDueDate(item?.rowData.due_date)
                    }
                    if (item.name === 'View Request') {
                      e.preventDefault()
                      setIsView(true);
                      setIsEdit(false);
                      if (item?.rowData.request_type === 'ADVANCE') {
                        setShowAddAdvancePopup(true);
                      }
                      if (item?.rowData.request_type === 'PAYMENT') {
                        setShowAddPaymentPopup(true);
                      }
                      if (item?.rowData.request_type === 'ADJUSTMENT') {
                        setShowAdjustAdvancePopup(true);
                      }
                      setCurrentRowData(item?.rowData)
                      setCurrentBusinessId(item?.rowData.businessId)
                      setCurrentInvoiceId(item?.rowData.invoice_id)
                      setCurrentContractId(item?.rowData.contract_id);
                      setCurrentSiteNumber(item?.rowData.site_number)
                      setCurrentBusinessName(item?.rowData.business)
                      setCurrentContractType(item?.rowData.contract_type)
                      setLateFeeApplicable(item?.rowData.is_late_fee_applicable)
                      setLateFee(item?.rowData.late_fee_amount)
                      setDueDate(item?.rowData.due_date)
                    }
                    if (item.name === 'Change Status') {
                      // console.log(item);
                      e.preventDefault();
                      setProjectId(item?.rowData?.infra_id);
                      setStartDate(item?.rowData?.start_date);
                      setEndDate(item?.rowData?.end_date);
                      setCurrentcarnivalStatus(item?.rowData?.status);
                      setChangeStatus(true);
                      setCarnivalId(item?.rowData?.id);
                      setChangeCarLoanStatusModalOpen(true)
                      console.log(id)
                      carLoanId(id)
                    }
                    if (item.name === 'Raise Claim') {
                      e.preventDefault();
                      setShowRaisePopup(true);
                      setUnclaimedId(id)
                      // console.log(id);
                      setPaymentReference(item?.PaymentRef);
                      setModeOfCollection(item?.mode_of_collection);
                      setUnclaimedAmount(item?.unclaimed_amount);
                    }

                    if (item.name === 'Assign Location') {
                      e.preventDefault();
                      setShowAssignLocationPopup(true);
                      setLocationAssignUserId(item?.locationAssignUserId)
                    }

                    if (item.name === 'Assign Reportee') {
                      e.preventDefault();
                      setShowAssigReporteePopup(true);
                      setLocationAssignUserId(item?.locationAssignUserId)
                      setReportingToRoleId(item?.roleId)
                    }

                    if (item.name === 'Edit Credit Limit') {
                      e.preventDefault();
                      setShowEditCreditPopup(true);
                      setCreditLimit(item?.creditLimit);
                      setCreditExhausted(item?.creditExhausted);
                      setCreditRemaining(item?.creditRemaining);
                      setUserId(item?.userId);
                      setDepartmentId(item?.departmentId);
                      setUserName(item?.userName);
                      setDepartmentName(item?.departmentName);
                      setType(item?.type);
                      setMonthlyAverageRevenue(item?.monthlyAverageRevenue);
                      setResponsibleEmail(item?.responsibleEmail);
                      setResponsibleDepartment(item?.responsibleDepartment);
                      setTeamId(item?.teamId);
                      setTeamName(item?.teamName);
                      setExpectedCreditLimit(item?.expectedCreditLimit);
                    }

                    if (item.name === 'Retag Invoice') {
                      e.preventDefault();
                      setShowRetagInvoicePopup(true);
                      setEmployeeCreditLimit(item?.employeeCreditLimit);
                      setEmployeeCreditRemaining(item?.employeeCreditRemaining);
                      setEmployeeResponsibleEmail(item?.employeeResponsibleEmail);
                      setEmployeeResponsibleDepartment(item?.employeeResponsibleDepartment);
                      setEmployeeDepartmentId(item?.employeeDepartmentId);
                      setEmployeeTeamName(item?.employeeTeamName);
                      setEmployeeTeamId(item?.employeeTeamId);
                    }
                   
                    if (item.name === 'Create Invoice') {
                      e.preventDefault();
                      setInvoiceValidationCompletePopup(true);
                      setCampaignId(id);
                    }

                    if (item.name === 'Assign Engineer') {
                      e.preventDefault();
                      assignEngineerPopup(true);
                      setUnclaimedId(item?.link)
                    }

                    if (item.name === 'Change Responsible Manager') {
                      e.preventDefault();
                      changeResponsibleManagerPopup(true);
                      setUnclaimedId(item?.link);
                    }

                    if (item.name === 'Close Ticket') {
                      console.log(id)
                      e.preventDefault();
                      installmentRequestId(id)
                      setCloseModal(!closeModal)
                    }

                    if (item.name === 'Sheet Status') {
                      e.preventDefault();
                      setBankSheetId(id)
                    }
                    if(item.name === 'Update Renewal Status') {
                      e.preventDefault();
                      setRequestForContractExpiry(id)
                      setContractStatusModalOpenForContractExpiry(true)
                    }
                    if(item.name === 'Assign') {
                      e.preventDefault();
                      setCentralTechChangeAssigns(id)
                      setChangeAssignModalOpenForCentralTech(true)
                    }
                    if(item.name === 'Delete MRF Type') {
                      e.preventDefault();
                      setShowDeleteMrfTypePopup(true);
                      setSelectedMrfTypeId(item?.id);
                    }
                  }}
                >
                  {item.name}
                </Dropdown.Item>
              );
            })}
        </Dropdown.Menu>
      </Dropdown>
      <ModalPop
        title={localization.approvePmTicket}
        show={isModal}
        handleModalHide={openHideModal}
        keyboard
        backdrop
      >
        <div className={`text-center ${isFiled ? 'requiredFileds' : ''}`}>
          <h5>{localization.approvalCondition}</h5>
          <DropDownInput
            label={localization.selectCondition}
            data={[{ id: 5, name: 'Closed' }]}
            required
            isStarRequired={true}
            errorMsg={localization.isRequired}
            getIdValue={(val) => {
              setAssigneeId(val.id);
            }}
          />
          <Button
            className="btn btn-primary mb-4"
            onClick={() => {
              if (postUpdatePMStatus !== null) {
                updatePMStatus();
              }
            }}
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.conf}
        show={successModal}
        handleModalHide={() => {
          setSuccessModal(false);
          refreshPage(true);
        }}
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.approvedSuccessfully}</h5>
          <Button
            onClick={() => {
              setSuccessModal(false);
              refreshPage(true);
            }}
            className="btn btn-primary mb-4"
          >
            {localization.continue} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.updateClient}
        show={editModal}
        handleModalHide={() => {
          setEditModal(false);
        }}
        keyboard
        backdrop
      >
        <div className={`text-center ${isFiled ? 'requiredFileds' : ''}`}>
          {/* <h5>{localization.approvalCondition}</h5> */}
          <ConstantInput
            label={localization.companyName}
            regex={Regex.text.test(editClientData.company_name)}
            errorMsg={localization.requiredCompanyName}
            type="text"
            required
            isStarRequired={true}
            handleChange={(value) => {
              setEditClientData({ ...editClientData, company_name: value });
            }}
          />
          <Button
            className="btn btn-primary mb-4"
            onClick={() => {
              updateCorp();
            }}
          >
            {localization.update} <img src={Images?.ArrowRight} alt="" />
          </Button>
        </div>
      </ModalPop>

      <ModalPop
        title={localization.delete}
        show={deleteCorClient}
        handleModalHide={() => {
          setDeleteCorClient(false);
        }}
        keyboard
        backdrop
      >
        <h5>{localization.clientMsg}</h5>
        <Button
          className="btn btn-primary mb-4"
          onClick={() => {
            deleteClientCrop();
          }}
        >
          {localization.yes} <img src={Images?.ArrowRight} alt="" />
        </Button>
        <Button
          onClick={() => setDeleteCorClient(false)}
          className="btn btn-transparent"
        >
          {localization.close} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </ModalPop>

      <ModalPop
        title={localization.delete}
        show={deleteMrfModal}
        handleModalHide={() => {
          setDeleteMrfModal(false);
        }}
        keyboard
        backdrop
      >
        <h5>{localization.mrfDetailMsg}</h5>
        <Button
          className="btn btn-primary mb-4"
          onClick={() => {
            deleteMrfDetails();
          }}
        >
          {localization.yes} <img src={Images?.ArrowRight} alt="" />
        </Button>
        <Button
          onClick={() => setDeleteMrfModal(false)}
          className="btn btn-transparent"
        >
          {localization.close} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </ModalPop>
    </Fragment>
  );
};

export default ActionDropDown;
